import React from "react";

export default function SliderComponent({ setShowLogin, isMobile }) {
    function handleSignInClick() {
        setShowLogin(true);
    }

    // Inline style object using your provided styles
    const signInButton = {
        backgroundColor: "#2a0947",
        color: "white",
        fontSize: isMobile ? "14px" : "16px",
        fontFamily: "Lato, sans-serif",
        fontWeight: "bold",
        borderRadius: "16px",
        width: isMobile ? "80px" : "90px",
        height: isMobile ? "36px" : "40px",
        border: "none",
        cursor: "pointer",
        marginLeft: isMobile ? "auto" : "0",
    };

    return <button onClick={handleSignInClick} style={signInButton}>Sign In</button>;
}
